module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h1', {
    ref: "timetable"
  }, [_vm._v("\n    Workshop timetable\n  ")]), _vm._v(" "), (!_vm.workshops) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n    Loading workshops...\n  ")]) : _vm._e(), _vm._v(" "), (_vm.workshops && _vm.workshops.length <= 0) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "notification"
  }, [_vm._v("\n      All workshops have been postponed until futher notice\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "blurred filter-wrapper",
    class: {
      'workshop-filter-active': _vm.workshopFilterActive
    }
  }, [_c('div', {
    staticClass: "filters"
  }, [(_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Type:")]), _vm._v(" "), _c('a', {
    key: 'all',
    class: {
      'active': _vm.workshopTypeFilter === ''
    },
    on: {
      "click": function($event) {
        _vm.workshopTypeFilter = ''
      }
    }
  }, [_vm._v("All Workshops")]), _vm._v(" "), _vm._l((_vm.typesOfWorkshops), function(type) {
    return _c('a', {
      key: type,
      class: {
        'active': _vm.workshopTypeFilter === type
      },
      on: {
        "click": function($event) {
          _vm.workshopTypeFilter = type
        }
      }
    }, [_vm._v("\n          " + _vm._s(type) + "\n        ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Dates:")]), _vm._v(" "), _c('a', {
    key: 'all',
    class: {
      'active': _vm.workshopMonthFilter === ''
    },
    on: {
      "click": function($event) {
        _vm.workshopMonthFilter = ''
      }
    }
  }, [_vm._v("All Dates")]), _vm._v(" "), _vm._l((_vm.monthsOfWorkshops), function(month) {
    return _c('a', {
      key: month,
      class: {
        'active': _vm.workshopMonthFilter === month
      },
      on: {
        "click": function($event) {
          _vm.workshopMonthFilter = month
        }
      }
    }, [_vm._v(_vm._s(month))])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter-display"
  }, [(!_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing all up coming workshops\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing all workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing all up coming " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops\n      ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n        Showing " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-display-action",
    on: {
      "click": function($event) {
        _vm.workshopFilterActive = !_vm.workshopFilterActive
      }
    }
  }, [(_vm.workshopFilterActive) ? _c('span', [_vm._v("Hide Filters")]) : _vm._e(), _vm._v(" "), (!_vm.workshopFilterActive) ? _c('span', [_vm._v("Show Filters")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
    staticClass: "filter-display",
    class: {
      'workshop-filter-active': _vm.workshopFilterActive
    }
  }, [(!_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing all up coming workshops\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing all workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && !_vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing all up coming " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops\n    ")]) : _vm._e(), _vm._v(" "), (_vm.workshopTypeFilter && _vm.workshopMonthFilter) ? _c('div', {}, [_vm._v("\n      Showing " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops in " + _vm._s(_vm.workshopMonthFilter) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filter-display-action",
    on: {
      "click": function($event) {
        _vm.workshopFilterActive = !_vm.workshopFilterActive
      }
    }
  }, [(_vm.workshopFilterActive) ? _c('span', [_vm._v("Hide Filters")]) : _vm._e(), _vm._v(" "), (!_vm.workshopFilterActive) ? _c('span', [_vm._v("Show Filters")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('transition-group', {
    staticClass: "listings",
    class: {
      'workshop-filtering': _vm.workshopFilteringInProgress
    },
    attrs: {
      "name": "",
      "tag": "div"
    }
  }, [((_vm.workshops && _vm.workshops.length > 0) && (_vm.computedWorkshops && _vm.computedWorkshops.length == 0)) ? _c('div', {
    key: 'no-results',
    staticClass: "filter-empty"
  }, [_vm._v("\n      No matching results\n      "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.workshopTypeFilter = ''
      }
    }
  }, [_vm._v("Browse all workshops in " + _vm._s(_vm.workshopMonthFilter))]), _vm._v(" or "), _c('a', {
    on: {
      "click": function($event) {
        _vm.workshopMonthFilter = ''
      }
    }
  }, [_vm._v("Browse all " + _vm._s(_vm.getFilterTypeName(_vm.workshopTypeFilter)) + " workshops")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.computedWorkshops), function(workshop, index) {
    return (_vm.workshops && _vm.workshops.length > 0) ? _c('div', {
      key: workshop.node.id,
      staticClass: "listing list-complete-item"
    }, [_c('div', {
      staticClass: "listing-content"
    }, [_c('div', {
      staticClass: "image"
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h3', {
      domProps: {
        "innerHTML": _vm._s(workshop.productTitle)
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(workshop.productDate))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(workshop.productTime))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(workshop.productPrice))])]), _vm._v(" "), _c('div', {
      staticClass: "action"
    }, [_c('a', {
      attrs: {
        "href": workshop.productUrl
      }
    }, [_vm._v("Details →")]), _vm._v(" "), _c('div', {
      staticClass: "status"
    }, [(!(workshop.productAvailableForSale)) ? _c('span', [_vm._v("Sold Out")]) : _vm._e()])])])]) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d65b1f2","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timetable.vue
// module id = 220
// module chunks = 1